var _mask, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveSelectFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_676_3492",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 1,
    fill: "#404D6A",
    stroke: "#404D6A",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_676_3492)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2806 8.46899C16.3503 8.53864 16.4056 8.62136 16.4433 8.71241C16.4811 8.80346 16.5005 8.90105 16.5005 8.99961C16.5005 9.09818 16.4811 9.19577 16.4433 9.28682C16.4056 9.37787 16.3503 9.46058 16.2806 9.53024L11.0306 14.7802C10.9609 14.85 10.8782 14.9053 10.7871 14.943C10.6961 14.9808 10.5985 15.0002 10.4999 15.0002C10.4014 15.0002 10.3038 14.9808 10.2127 14.943C10.1217 14.9053 10.039 14.85 9.9693 14.7802L7.7193 12.5302C7.57857 12.3895 7.49951 12.1986 7.49951 11.9996C7.49951 11.8006 7.57857 11.6097 7.7193 11.469C7.86003 11.3283 8.05091 11.2492 8.24993 11.2492C8.44895 11.2492 8.63982 11.3283 8.78055 11.469L10.4999 13.1893L15.2193 8.46899C15.289 8.39926 15.3717 8.34394 15.4627 8.30619C15.5538 8.26845 15.6514 8.24902 15.7499 8.24902C15.8485 8.24902 15.9461 8.26845 16.0371 8.30619C16.1282 8.34394 16.2109 8.39926 16.2806 8.46899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSelectFilled);
export default __webpack_public_path__ + "static/media/active-select-filled.b7bac23e7d6b9385925140a981e35d29.svg";
export { ForwardRef as ReactComponent };